import React from "react"

import DataSource      from "../../../types/DataSource"
import ItemViewHeader  from "../../common/Headers/ItemViewHeader"
import IconDataSource from "../../common/Icons/DataSource";

export interface componentProps {
    item: DataSource
}

const Header: React.FC<componentProps> = ({item}) => {

    const linkSegment = 'view'
        , text = item.name

    return <ItemViewHeader
        icon={<IconDataSource link={'/data-sources/' + item.id + '/' + linkSegment} text={text} />}
        title={text}
        subTitle={item.dataSourceType?.name || ''}
    />

}

export default Header